import { Database } from 'lucide-react'
import type { InvestigationLabels, InvestigationSource } from '@/frontend/features/Fde/investigations/types'

interface Props {
  sources: InvestigationSource[]
  selected: string[]
  onChange: (ids: string[]) => void
  copy: InvestigationLabels
  disabled: boolean
}

export default function SourcePicker({ sources, selected, onChange, copy, disabled }: Props) {
  const allSelected = sources.length > 0 && sources.every((source) => selected.includes(source.id))
  const toggle = (id: string) => onChange(selected.includes(id) ? selected.filter((item) => item !== id) : [...selected, id])
  return <fieldset disabled={disabled} className="grid min-w-0 gap-3">
    <legend className="mb-3 text-sm font-medium">{copy.sources}</legend>
    <label className="flex cursor-pointer items-center gap-2.5 text-sm">
      <input type="checkbox" checked={allSelected} onChange={() => onChange(allSelected ? [] : sources.map((source) => source.id))} className="size-4 rounded border-input accent-primary" />
      {copy.all_sources}
    </label>
    <div className="grid max-h-56 gap-1 overflow-auto rounded-lg border border-border p-1">
      {sources.map((source) => <label key={source.id} className="flex cursor-pointer items-center gap-3 rounded-md px-3 py-2.5 hover:bg-muted/50">
        <input type="checkbox" checked={selected.includes(source.id)} onChange={() => toggle(source.id)} className="size-4 rounded border-input accent-primary" />
        <Database className="size-4 shrink-0 text-muted-foreground" aria-hidden />
        <span className="grid min-w-0 gap-0.5"><span className="truncate text-sm font-medium">{source.name}</span><span className="text-xs text-muted-foreground">{source.connector}</span></span>
      </label>)}
    </div>
    <p className="text-xs text-muted-foreground">{copy.sources_hint}</p>
  </fieldset>
}
